"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _react = _interopRequireWildcard(require("react")),
    _classnames = _interopRequireDefault(require("classnames")),
    _radioButton = require("../styles/radioButton"),
    _Text = _interopRequireDefault(require("../../Text")),
    _Icon = _interopRequireDefault(require("../../Icon")),
    _onEnterPressed = _interopRequireDefault(require("../../../common/utils/onEnterPressed"));

function RadioButton(a) {
  var b,
      c,
      d = a.selected,
      e = a.onChange,
      f = a.children,
      g = a.disabled,
      h = a.darkMode,
      i = a.prefixIcon;
  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])((0, _radioButton.BUTTON_CONTAINER)({
      selected: d,
      darkMode: h,
      disabled: g
    }), "radio-button", (b = {
      "radio-button--selected": d
    }, (0, _defineProperty2["default"])(b, _radioButton.BUTTON_CONTAINER_DISABLED, g), (0, _defineProperty2["default"])(b, "radio-button--disabled", g), b)),
    onKeyDown: !g && (0, _onEnterPressed["default"])({
      onChange: e
    }),
    onClick: !g && e,
    tabIndex: 0,
    role: "button"
  }, _react["default"].createElement("div", {
    className: (0, _classnames["default"])((0, _radioButton.BUTTON)({
      selected: d,
      darkMode: h
    }), "radio-button__button", (c = {}, (0, _defineProperty2["default"])(c, _radioButton.BUTTON_DISABLED, g), (0, _defineProperty2["default"])(c, "radio-button__button--disabled", g), c))
  }, d ? _react["default"].createElement("div", {
    className: (0, _classnames["default"])(_radioButton.BUTTON_CENTER, "radio-button__button__center")
  }) : null), _react["default"].createElement("div", {
    className: (0, _classnames["default"])(_radioButton.BUTTON_CONTENT, "radio-button__button__content")
  }, i && _react["default"].createElement(_Icon["default"], {
    size: 20,
    color: "denim",
    name: i
  }), "string" == typeof f ? _react["default"].createElement(_Text["default"], {
    noMargin: !0
  }, f) : f));
}

var _default = (0, _react.memo)(RadioButton);

exports["default"] = _default;